import Vue from 'vue';
import * as types from './types';

export default {
  [types.GET_CONTENT] (state, content) {
    // state.content = content;
    Vue.set(state, 'content', content);
  },

  [types.ROUTE_CHANGE] (state, prevRoute) {
    Vue.set(state.routes, 'prevRoute', prevRoute);
  },

  [types.IS_PRELOADING] (state) {
    Vue.set(state.ui, 'isPreloading', true);
  },

  [types.HAS_PRELOADED] (state) {
    Vue.set(state.ui, 'isPreloading', false);
    Vue.set(state.ui, 'hasPreloaded', true);
  },

  [types.HAS_PRELOADED_HALF] (state) {
    Vue.set(state.ui, 'hasPreloadedHalf', true);
  },

  [types.LOGO_ANIMATED] (state) {
    Vue.set(state.ui, 'logoAnimated', true);
  },

  [types.TOGGLE_CLASS] (state, className) {
    Vue.set(state.ui, className, !state.ui[className]);
  },

  [types.SHOW_NAV] (state) {
    Vue.set(state.ui, 'showNav', true);
  },

  [types.HIDE_NAV] (state) {
    Vue.set(state.ui, 'showNav', false);
  },

  [types.NOT_TOUCH_DEVICE] (state) {
    Vue.set(state.ui, 'isTouchDevice', false);
  }
};



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/store/mutations.js